<template>
  <div>
    <h3>E106 Compliance Requests</h3>
     <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
            <loader v-if="loading"></loader>
            <div class="col-md-2 form-group" v-if="isUserRc && type ==='todo'">
                <div class="pull-right">
                    <input class="form-check-input" type="checkbox" v-model="searchDto.showAll" style="width: 20px; height: 20px;">
                </div>
                <div class="pull-right">
                    <label class="form-check-label" for="showAll">Show All&nbsp;</label>
                </div>
            </div>
            <div>
                <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options" ref="complianceTable">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center;">
                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.e106complianceId)"></a> -->
                        <router-link :to="{ path: '/E106Compliance/' + props.row.e106complianceId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                    </div>
                </template>
                </v-client-table>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import e106ComplianceService from '../services/e106ComplianceService'

import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    props: {
        type: {
            type: String,
            default: 'search'
        },
        isUserRc: { default: false }
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            searchDto: {
                showAll: false
            },
            gridSpec: {
                columns: ['edit', 'workflowStatusDescription', 'projectName', 'latestUpdate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['latestUpdate'],
                    headings: {
                        edit: 'View/Edit',
                        latestUpdate: 'Status Date',
                        workflowStatusDescription: 'Status',
                        projectName: 'Project Title',
                        fieldOrgDescription: 'Field Org',
                        agencyDescription: 'Lead Agency',
                        createdBy: 'Submitted By',
                        assignedUserName: 'Assigned To'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'latestUpdate'
                    }
                }
            }
        }
    },
    watch: {
        'searchDto.showAll': function () {
            this.loadData()
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'E106 Compliance Requests', 'mounted')
        this.loadData()
    },
    methods: {
        loadData () {
            loggingService.log(this.isDebug, 'E106 Compliance Requests', 'loadData, type: ' + this.type)

            var handle = this
            handle.loading = true

            if (this.type === 'search') {
                e106ComplianceService.search(this.$http, this.searchDto).then(function (response) {
                    loggingService.log(handle.isDebug, 'E106 Compliance Requests', 'e106ComplianceService.loadData.search.then')

                    handle.gridSpec.tableData = response.data
                    handle.loading = false
                })
            } else if (this.type === 'todo') {
                e106ComplianceService.todo(this.$http, this.searchDto).then(function (response) {
                    loggingService.log(handle.isDebug, 'E106 Compliance Requests', 'e106ComplianceService.loadData.todo.then')

                    handle.gridSpec.tableData = response.data
                    handle.gridSpec.columns.push('createdBy')
                    handle.gridSpec.columns.push('fieldOrgDescription')
                    handle.gridSpec.columns.push('agencyDescription')
                    handle.gridSpec.columns.push('assignedUserName')
                    handle.loading = false
                })
            } else {
                loggingService.log(this.isDebug, 'E106 Compliance Requests', 'e106ComplianceService.loadData - unknown type: ' + this.type)
            }
            handle.$refs.complianceTable.setData
        },
        editRow (id) {
            loggingService.log(this.isDebug, 'E106 Compliance Requests', 'editRow: ' + id)
            this.$router.push('/E106Compliance/' + id)
        }
    }
}
</script>



// WEBPACK FOOTER //
// E106Compliances.vue?026c4820